import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["key"];
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useLayoutEffect, useRef, useState } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { akEditorFullWidthLayoutWidth } from '@atlaskit/editor-shared-styles';
import { VAR_POSITION_OFFSET_X, VAR_POSITION_OFFSET_Y } from './constants';
import { Guideline } from './guideline';
var guidelineContainerStyles = css({
  position: 'fixed',
  height: '100vh',
  width: '100%',
  display: 'grid',
  pointerEvents: 'none',
  border: 'none',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  maxWidth: "".concat(akEditorFullWidthLayoutWidth, "px")
});
export var GuidelineContainer = function GuidelineContainer(props) {
  var guidelines = props.guidelines,
    height = props.height,
    updateRect = props.updateRect;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    offset = _useState2[0],
    setOffset = _useState2[1];
  var ref = useRef(null);
  useLayoutEffect(function () {
    var _ref$current;
    var rect = ref === null || ref === void 0 || (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.getBoundingClientRect();
    if (rect) {
      var centerOffset = rect.width / 2 - 0.5;

      // X pixels from guideline container left to editor center.
      if (offset !== centerOffset) {
        setOffset(centerOffset);
      }
      updateRect({
        top: rect.top,
        left: rect.left
      });
    }
  }, [updateRect, offset]);
  var style = _defineProperty(_defineProperty(_defineProperty({}, VAR_POSITION_OFFSET_X, "".concat(offset, "px")), VAR_POSITION_OFFSET_Y, "0px"), "height", height);
  return jsx("div", {
    ref: ref,
    css: guidelineContainerStyles
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    ,
    style: style,
    "data-testid": "guidelineContainer"
  }, guidelines.map(function (guideline) {
    var key = guideline.key,
      guidelineProps = _objectWithoutProperties(guideline, _excluded);

    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return jsx(Guideline, _extends({
      key: key
    }, guidelineProps));
  }));
};